/**
 * Variant Selector Component
 *
 * Renders the selectable variants of a product as a row of mini-cards.
 * Single-select: choosing a variant adds that variant's product to the configuration.
 *
 * @package
 */

import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';
import VariantCard from './VariantCard';

const VariantSelector = ( { variants, selectedVariant, onSelect, vatMode, heading, ariaLabel, disabled } ) => {
	if ( ! Array.isArray( variants ) || variants.length === 0 ) {
		return null;
	}

	const headingId = heading ? 'configurator-variant-selector-heading' : undefined;

	return (
		<div className="configurator-variant-selector">
			{ heading && (
				<div className="configurator-variant-selector-heading" id={ headingId }>
					{ heading }
				</div>
			) }
			<div
				className="configurator-variant-cards"
				role="radiogroup"
				aria-labelledby={ headingId }
				aria-label={ heading ? undefined : ariaLabel }
			>
				{ variants.map( variant => (
					<VariantCard
						key={ variant.id }
						variant={ variant }
						isSelected={ selectedVariant === variant.id }
						onSelect={ () => ! disabled && onSelect( variant.id ) }
						vatMode={ vatMode }
						disabled={ disabled }
					/>
				) ) }
			</div>
		</div>
	);
};

VariantSelector.propTypes = {
	variants: PropTypes.array,
	selectedVariant: PropTypes.number,
	onSelect: PropTypes.func.isRequired,
	vatMode: PropTypes.oneOf( [ 'including', 'excluding' ] ).isRequired,
	heading: PropTypes.string,
	ariaLabel: PropTypes.string,
	disabled: PropTypes.bool,
};

VariantSelector.defaultProps = {
	variants: [],
	selectedVariant: null,
	heading: __( 'Choose variant', 'at-vehicle-configurator' ),
	ariaLabel: undefined,
	disabled: false,
};

export default VariantSelector;
